import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom"; // ✅ get :id from route
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import db from "./Firebase";
import { doc, getDoc } from "firebase/firestore";

export default function ApplicationForm() {
    const { id } = useParams(); // ✅ URL param e.g. /applicationForm/:id
    const pageRef = useRef();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!id) {
            alert("No document ID provided in URL.");
            setLoading(false);
            return;
        }

        async function fetchData() {
            try {
                const docRef = doc(db, "registration_form_data", id);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setData(docSnap.data());
                } else {
                    alert("Document not found.");
                }
            } catch (error) {
                console.error("Error fetching document:", error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [id]);

    const downloadPdf = async () => {
        const page = pageRef.current;
        const scale = 2;
        const canvas = await html2canvas(page, {
            scale,
            backgroundColor: "#ffffff",
            useCORS: true,
            allowTaint: true,
            scrollY: 0,
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.98);
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        const pageWidth = 210;
        const imgHeight = (canvas.height * pageWidth) / canvas.width;

        if (imgHeight < 297) {
            pdf.addImage(imgData, "JPEG", 0, 0, pageWidth, imgHeight);
        } else {
            let heightLeft = imgHeight;
            let y = 0;
            while (heightLeft > 0) {
                pdf.addImage(imgData, "JPEG", 0, y, pageWidth, imgHeight);
                heightLeft -= 297;
                if (heightLeft > 0) {
                    pdf.addPage();
                    y -= 297;
                }
            }
        }

        pdf.save(`Application_Form_${data.applicantName || "Applicant"}.pdf`);
    };

    if (loading) return <div>Loading...</div>;

    return (
        <>
            <div>
                <div className="toolbar">
                    <button className="btn" onClick={downloadPdf}>
                        Download PDF
                    </button>
                </div>

                <div id="page" className="" ref={pageRef} style={{
                    width: "210mm", minHeight: "297mm", margin: "2mm auto", background: "var(--paper)", boxShadow: "0 8px 28px rgba(0, 0, 0, .12)",
                    padding: "6mm 12mm 14mm", position: "relative"
                }}>
                    <header className="form-head">
                        <div className="left">
                            -CSR Initiative of-
                            <br />
                            <img src="/images/atos.png" alt="Atos Prayas Foundation" />
                        </div>
                        <div className="mid"></div>
                        <div className="right">
                            -Implementing Partner-
                            <br />
                            <img
                                src="/images/empowerfoundation.png"
                                alt="Empower Foundation"
                            />
                        </div>
                    </header>

                    <div className="section-title">Application Form</div>

                    <div className="grid-2">
                        <div>
                            <div className="row">
                                <span className="label">Name of the Applicant:</span>
                                <span className="field">{data.applicantName}</span>
                            </div>
                            <div className="row">
                                <span className="label">Course applied for:</span>
                                <span className="field">{data.course}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Preferred Batch:
                                </span>
                                <span className="field">{data.batch}</span>
                            </div>

                            <div className="row">
                                <span className="label">Date of birth:</span>
                                <span className="field">{data.dob}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Age:
                                </span>
                                <span className="field">{data.age}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Gender:
                                </span>
                                <span className="field">{data.gender}</span>
                            </div>

                            <div className="row">
                                <span className="label">Educational Qualification:</span>
                                <span className="field">{data.qualification}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Contact No.
                                </span>
                                <span className="field">{data.contact1}</span>
                            </div>

                            <div className="row">
                                <span className="label">Residential address:</span>
                                <span className="field">{data.address}</span>
                            </div>

                            <div className="row">
                                <span className="label">Name of father/guardian:</span>
                                <span className="field">{data.fatherName}</span>
                            </div>

                            <div className="row">
                                <span className="label">Contact No.</span>
                                <span className="field">{data.contact2}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Occupation:
                                </span>
                                <span className="field">{data.fatherOccupation}</span>
                            </div>

                            <div className="row">
                                <span className="label">Name of mother:</span>
                                <span className="field">{data.motherName}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Occupation:
                                </span>
                                <span className="field">{data.motherOccupation}</span>
                            </div>

                            <div className="row">
                                <span className="label">Type of family:</span>
                                <span className="field">{data.familyType}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Monthly family income:
                                </span>
                                <span className="field">{data.income}</span>
                            </div>

                            <div className="row">
                                <span className="label">Social Group:</span>
                                <span className="field">{data.group}</span>
                            </div>

                            <div className="row">
                                <span className="label">Documents attached:</span>
                                <span className="field">{data.documents}</span>
                            </div>

                            <div className="row">
                                <span className="label">
                                    Would you like to go for employment on completion of course?
                                </span>
                                <span className="field">{data.jobPreference}</span>
                            </div>

                            <div className="row">
                                <span className="label">Date of application:</span>
                                <span className="field">{data.doa}</span>
                                <span className="label" style={{ marginLeft: "12px" }}>
                                    Applicant’s signature:
                                </span>
                            </div>

                            {data.signature && (
                                <img
                                    src={data.signature}
                                    alt="Applicant Signature"
                                    className="sign-img"
                                    style={{ marginTop: "-12mm", marginLeft: "122mm" }}
                                />
                            )}
                        </div>

                        <div className="photo-box">
                            {data.photo && (
                                <img src={data.photo} alt="Applicant" id="applicant-photo" />
                            )}
                        </div>
                    </div>

                    {/* Declaration */}
                    <div className="section-title" style={{ marginTop: "8mm" }}>
                        Declaration from Parent
                    </div>
                    <div className="row" style={{ lineHeight: "1.7" }}>
                        <span className="label">1.</span>
                        <span>
                            I {data.declarationName} declare that the above details given by my
                            son/daughter {data.declarationChildName} are correct.
                        </span>
                    </div>
                    <div className="row" style={{ lineHeight: "1.7" }}>
                        <span className="label">2.</span>
                        <span>
                            My son/daughter is interested to take up a job after completing the
                            training of {data.declarationCourse} under CSR programme of Atos
                            Prayas Foundation.
                        </span>
                    </div>

                    <div className="row">
                        <span className="label">Date of declaration:</span>
                        <span className="field">{data.declarationDate}</span>
                        <span className="label" style={{ marginLeft: "12px" }}>
                            Parent's signature:
                        </span>
                    </div>

                    {data.declarationSignature && (
                        <img
                            src={data.declarationSignature}
                            alt="Parent Signature"
                            className="sign-img"
                            style={{ marginTop: "-12mm", marginLeft: "155mm" }}
                        />
                    )}

                    {/* FOR OFFICE USE */}
                    <div className="section-title" style={{ marginTop: "8mm" }}>
                        FOR OFFICE USE ONLY
                    </div>

                    <div className="office">
                        <div className="row">
                            <span className="label">Training Centre:</span>
                            <span className="field">{data.centre}</span>
                        </div>
                        <div className="row">
                            <span className="label">Referred by:</span>
                            <span className="field">{data.referredBy}</span>
                        </div>
                        <div className="row">
                            <span className="label">Registration No.:</span>
                            <span className="field">{data.regNo}</span>
                            <span className="label" style={{ marginLeft: "12px" }}>
                                Batch No.:
                            </span>
                            <span className="field">{data.batchNo}</span>
                        </div>
                        <div className="row">
                            <span className="label">Documents Submitted:</span>
                            <span className="field">{data.docsSubmitted}</span>
                        </div>
                        <div className="row">
                            <span className="label">Date:</span>
                            <span className="field">{data.officeDate}</span>
                            <span className="label" style={{ marginLeft: "12px" }}>
                                In-charge Name:
                            </span>
                            <span className="field">{data.inChargeName}</span>
                        </div>

                        <div style={{ display: "flex", justifyContent: "end" }}>
                            <img
                                src="/images/stamp.png"
                                className="sign-img"
                                alt="stamp"
                                style={{
                                    marginTop: "-2mm",
                                    marginLeft: "15mm",
                                    position: "absolute",
                                }}
                            />
                            {data.inChargeSignature && (
                                <img
                                    src={data.inChargeSignature}
                                    className="sign-img"
                                    alt="center incharge"
                                    style={{ marginTop: "-2mm" }}
                                />
                            )}
                        </div>
                    </div>

                    <div style={{ marginTop: "5rem" }}>
                        <h3>Attached Documents:</h3>
                    </div>

                    <div className="image-grid">
                        {[data.uploadDoc1, data.uploadDoc2, data.uploadDoc3, data.uploadDoc4, data.uploadDoc5]
                            .filter(Boolean)
                            .map((src, i) => (
                                <img key={i} src={src} alt={`Document ${i + 1}`} />
                            ))}
                    </div>
                </div>
            </div>

            <style>{`
                :root {
            --ink: #111;
            --muted: #5b6770;
            --blue: #e6f1fb;
            --line: #1a1a1a;
            --accent: #3b82f6;
            --paper: #ffffff;
        }

        * {
            box-sizing: border-box
        }

        html,
        body {
            margin: 0;
            background: #f2f2f7;
            color: var(--ink);
            font-family: 'Montserrat', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
        }






        /* Page setup (A4) */
        .page {
            width: 210mm;
            /* A4 width */
            min-height: 297mm;
            /* A4 height */
            margin: 2mm auto;
            background: var(--paper);
            box-shadow: 0 8px 28px rgba(0, 0, 0, .12);
            padding: 6mm 12mm 14mm;
            position: relative;
        }

        header.form-head {
            display: grid;
            grid-template-columns: 1fr auto 1fr;
            align-items: center;
            gap: 8px;
            margin-bottom: 6mm;
        }

        header.form-head .left,
        header.form-head .right {
            font-size: 12px;
            color: var(--muted);
            text-align: center;
            line-height: 1.2;
            font-weight: 600;
        }

        header.form-head img {
            max-height: 14mm;
            width: auto;
            object-fit: contain;
            display: block;
            margin: 0 auto;
        }

        .section-title {
            background: #d9ecff;
            color: #0e2d4d;
            padding: 6px 10px;
            border: 1px solid #bcd9fb;
            font-weight: 700;
            text-align: center;
            font-family: 'Syne', sans-serif;
            letter-spacing: .2px;
            margin: 2mm 0 3mm;
        }

        /* two-col content + photo */
        .grid-2 {
            display: grid;
            grid-template-columns: 1fr 38mm;
            gap: 8mm;
            align-items: start;
        }

        .photo-box {
            border: 1px solid #cbd5e1;
            padding: 2mm;
            height: 48mm;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f8fafc;
        }

        .photo-box img {
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
        }

        /* rows and underlines */
        /* fixes for inline underline layout */
        .row {
            display: flex;
            align-items: baseline;
            flex-wrap: wrap;
            font-size: 14px;
            line-height: 2.5;
            margin: 8px 0;
        }

        .label {
            font-weight: 600;
            white-space: nowrap;
        }

        .field {
            position: relative;
            flex: 1;
            border-bottom: 1px solid #000;
            margin: 0 4px;
            font-weight: 500;
            line-height: 1.1;
            margin-left: 2px;
            padding-left: 8px;
        }

        .field::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            border-bottom: 1px solid #000;
            z-index: -1;
        }

        .field span {
            position: relative;
            background: #fff;
            padding: 0 2px;
        }



        .val {
            font-weight: 600;
            padding: 0 3px;
            white-space: nowrap;
        }

        /* inline little blocks */
        .inline {
            display: inline-flex;
            align-items: baseline;
            gap: 6px;
            margin-right: 10px;
        }

        .check {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            margin-left: 8px;
            font-weight: 600;
        }

        /* Base empty checkbox */
        .box {
            width: 14px;
            height: 14px;
            border: 2px solid #000;
            display: inline-block;
            border-radius: 2px;
            position: relative;
        }

        /* Add blue tick when checked */
        .box.checked::after {
            content: "";
            position: absolute;
            left: 3px;
            top: -9px;
            width: 5px;
            height: 16px;
            border-right: 3px solid #1f6feb;
            border-bottom: 3px solid #1f6feb;
            transform: rotate(45deg);
        }


        .tick {
            display: inline-block;
            width: 14px;
            height: 14px;
            border-radius: 3px;
            border: 2px solid var(--ink);
            position: relative;
            top: 3px;
        }

        .tick::after {
            content: "";
            position: absolute;
            left: 2px;
            top: -1px;
            width: 7px;
            height: 13px;
            border-right: 3px solid #1f6feb;
            border-bottom: 3px solid #1f6feb;
            transform: rotate(45deg);
        }

        /* small text */
        .note {
            color: #374151;
            font-size: 12px;
            margin-top: 8mm;
        }

        /* foot rows */
        .footline {
            margin-top: 6mm;
            border-top: 1px solid #d1d5db;
            height: 0;
        }

        .signature-line {
            border-bottom: 1px solid var(--line);
            min-width: 40mm;
            height: 0;
            display: inline-block;
            vertical-align: middle;
        }

        .sign-img {
            max-height: 18mm;
            width: auto;
            object-fit: contain;
            display: block;
        }

        .sign-row {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            gap: 12px;
            margin-top: 6mm;
        }

        /* FOR OFFICE table-ish */
        .office {
            margin-top: 3mm;
        }

        .two {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 6mm;
        }

        .three {
            display: grid;
            grid-template-columns: 1.2fr 1fr 1fr;
            gap: 6mm;
        }

        .stamp {
            position: absolute;
            right: 18mm;
            bottom: 30mm;
            width: 20mm;
            opacity: .85;
        }

        /* Action bar (not printed) */
        .toolbar {
            max-width: 210mm;
            margin: 14px auto 0;
            display: flex;
            justify-content: flex-end;
            gap: 8px;
        }

        .btn {
            appearance: none;
            border: 0;
            padding: 10px 14px;
            border-radius: 8px;
            font-weight: 700;
            background: #111827;
            color: #fff;
            cursor: pointer;
        }

        .btn:active {
            transform: translateY(1px)
        }

        /* Print rules */
        @media print {
            body {
                background: #fff
            }

            .page {
                margin: 0;
                box-shadow: none;
                width: 210mm;
                min-height: 297mm;
            }

            .toolbar {
                display: none !important;
            }
        }

        .image-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            /* 2 equal columns */
            gap: 16px;
            /* spacing between images */
            max-width: 800px;
            margin: 0 auto;
            margin-top: 2rem;
        }

        .image-grid img {
            width: 100%;
            height: auto;
            border-radius: 8px;
            object-fit: cover;
        }

        /* For mobile responsiveness */
        @media (max-width: 600px) {
            .image-grid {
                grid-template-columns: 1fr;
                /* stack images on small screens */
            }
        }
        `}</style>
        </>
    );
}
